
export { SiteLocale } from "/home/runner/work/hultafors-web/hultafors-web/libs/hultaforsgroup/types/src/lib/dato/graphql-types.ts"